var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStatusApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000610352,
    width: 24,
    height: 24,
    rx: 8,
    fill: "#B3FB7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4765 7.64844C17.832 7.97656 17.832 8.55078 17.4765 8.87891L10.4765 15.8789C10.1484 16.2344 9.57416 16.2344 9.24603 15.8789L5.74603 12.3789C5.39056 12.0508 5.39056 11.4766 5.74603 11.1484C6.07416 10.793 6.64838 10.793 6.9765 11.1484L9.8476 14.0195L16.246 7.64844C16.5742 7.29297 17.1484 7.29297 17.4765 7.64844Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusApproved);
export default __webpack_public_path__ + "static/media/icon-status-approved.3ae0a4f69270fe4fb3c4edfa59dd1aa5.svg";
export { ForwardRef as ReactComponent };